/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignEventToEmployeeDTO } from '../models/AssignEventToEmployeeDTO';
import type { AssignOrderToEmployeeDTO } from '../models/AssignOrderToEmployeeDTO';
import type { EnrichedEventData } from '../models/EnrichedEventData';
import type { ShiftOut } from '../models/ShiftOut';
import type { ShiftsCreateDTO } from '../models/ShiftsCreateDTO';
import type { ShiftUpdate } from '../models/ShiftUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmployeesService {
  /**
   * Create Shifts
   * @param requestBody
   * @returns ShiftOut Successful Response
   * @throws ApiError
   */
  public static createShifts(requestBody: ShiftsCreateDTO): CancelablePromise<Array<ShiftOut>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/employees/create-shifts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Edit Shift
   * @param requestBody
   * @returns ShiftOut Successful Response
   * @throws ApiError
   */
  public static editShift(requestBody: ShiftUpdate): CancelablePromise<ShiftOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/employees/edit-shift',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Delete Shift
   * @param shiftId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static deleteShift(shiftId: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/employees/delete-shift',
      query: {
        shift_id: shiftId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Assign To Employee Order
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public static assignOrderToEmployee(requestBody: AssignOrderToEmployeeDTO): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/employees/assign-order-to-employee',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Assign To Employee Order
   * @param requestBody
   * @returns EnrichedEventData Successful Response
   * @throws ApiError
   */
  public static assignEventToEmployee(requestBody: AssignEventToEmployeeDTO): CancelablePromise<EnrichedEventData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/employees/assign-event-to-employee',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        422: `Validation Error`,
      },
    });
  }
}
